var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgActionOppsMoveOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 179.88 85.93"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.87 64h64V0h-64z",
    fill: "#00abff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.66 29.49a12.26 12.26 0 011.22-6 4.16 4.16 0 017 .07c.79 1.34 1.18 3.45 1.18 6.27v5.59c0 2.65-.41 4.62-1.19 5.85A3.75 3.75 0 01133.4 43a3.86 3.86 0 01-3.54-1.81c-.79-1.27-1.2-3.29-1.2-6v-5.7zm4.69-14.11a10.83 10.83 0 00-8.82 3.87c-2.1 2.55-3.16 6.12-3.16 10.61v5.51c0 4.34 1.12 7.77 3.23 10.2a11.12 11.12 0 008.8 3.68 11 11 0 008.79-3.72c2.09-2.45 3.15-5.92 3.15-10.32v-5.5c0-4.49-1.12-8-3.23-10.53a10.9 10.9 0 00-8.76-3.8zm39.84.44h-6.86v19.65l-8.74-19.41-.1-.24h-7.16v33h7.3V29.19l8.71 19.38.11.24h7.15v-33z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1 79.73h61.79v-64H61.1z",
    className: "a",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.86 30.79h-7.55l-.07.31-5 21.63-5-21.63-.07-.31h-8l.14.52 9.2 32.17.09.29h7.36l.08-.29 9.26-32.17.15-.52zm23.3 26.78h-11.55v-7.72h10.11V43.8h-10.11V37h11.92v-6.21H97.32v33h19.25v-6.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 85.93h71.42v-64H0z",
    className: "a",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.23 37h-8.79l-.08.3-5.65 21.76L16 37.29V37H6.77v33h7.3v-9.14l-.45-10 5.48 18.82.08.3h5l.08-.3 5.48-18.86-.44 10V70h7.31V37zm13.68 25.38c-.79-1.26-1.2-3.28-1.2-6v-5.73a12.32 12.32 0 011.22-6 4.16 4.16 0 017 .07A13 13 0 0158.07 51v5.59a11.43 11.43 0 01-1.19 5.85 3.76 3.76 0 01-3.43 1.76 3.84 3.84 0 01-3.54-1.81m12.25-22a10.92 10.92 0 00-8.76-3.8 10.83 10.83 0 00-8.82 3.87C42.48 43 41.42 46.53 41.42 51v5.5c0 4.34 1.11 7.77 3.23 10.2a11.1 11.1 0 008.8 3.69 11 11 0 008.79-3.73c2.09-2.45 3.15-5.92 3.15-10.31v-5.48c0-4.48-1.12-8-3.23-10.52"
  })));
}

export default SvgActionOppsMoveOn;